import { render, staticRenderFns } from "./PublicationsPage.vue?vue&type=template&id=a29bd710"
import script from "./PublicationsPage.vue?vue&type=script&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports